import Vue from "vue";
import VeeValidate from "vee-validate";
import "./Validation";
import axios from "axios";
import VueAxios from "vue-axios";
import LangMixin from "./Lang.mixin.js";
import GlobalStore from "./Global.store.js";
import App from "./App.vue";
import Forms from "./Forms.vue";
import AccountMerge from "./AccountMerge.vue";
import CrmAuth from "./CrmAuth.vue";
import CrmClientSearch from "./CrmClientSearch.vue";
import CrmClientReports from "./CrmClientReports.vue";
import Faq from "./FAQ.vue";
import Blacklist from "./Blacklist.vue";
import LanguageSwitch from "./LanguageSwitch.vue";
import CampaignDates from "./CampaignDates.vue";
import ReceivingNumbers from "./ReceivingNumbers.vue";
import Reports from "./Reports.vue";
import Beaconstac from "./Beaconstac.vue";
import BeaconstacCardScans from "./BeaconstacCardScans.vue";
import ExportLeads from "./ExportLeads.vue";
import ExportLoginHistory from "./ExportLoginHistory.vue";
import ExportInactiveNumbers from "./ExportInactiveNumbers.vue";
import CampaignMove from "./CampaignMove.vue";

Vue.config.ignoredElements = ["trix-editor"];

Vue.mixin(LangMixin);
Vue.use(VeeValidate);
Vue.use(VueAxios, axios);

new Vue({
  el: "#vueApp",
  data() {
    return {
      global: GlobalStore
    };
  },
  components: {
    App,
    Forms,
    AccountMerge,
    CrmAuth,
    CrmClientSearch,
    CrmClientReports,
    Faq,
    Blacklist,
    LanguageSwitch,
    CampaignDates,
    ReceivingNumbers,
    Reports,
    Beaconstac,
    beaconstaccardscans: BeaconstacCardScans,
    exportleads: ExportLeads,
    exportloginhistory: ExportLoginHistory,
    exportinactivenumbers: ExportInactiveNumbers,
    CampaignMove,
  }
});



// WEBPACK FOOTER //
// ./src/main.js